import '../theme/index.scss'

import type { AppProps } from 'next/app'
import { polyfill } from '../helpers/polyfill'

polyfill()

function _App({ Component, pageProps }: AppProps) {
  return <Component {...pageProps} />
}
export default _App
